import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import Card from '@plasma/ui.display.card';
import Button from '@plasma/ui.general.button';
import Input from '@plasma/ui.input.input';
import Modal from '@plasma/ui.layout.modal';
import Select from '@plasma/ui.input.select';
import SimpleList from '@plasma/ui.display.simple-list';

import { ProductFamiliesTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<ProductFamiliesTheme>;
const css = baseCss as ThemedCssFunction<ProductFamiliesTheme>;

export const ProductFamilies = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.mode.productFamilies.backgroundColor};
  background: ${(props) => props.theme.mode.productFamilies.backgroundGradient};
`;


export const ProductDetail = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.mode.productFamilies.backgroundColor};
  background: ${(props) => props.theme.mode.productFamilies.backgroundGradient};
`;

export const CustomModal = styled(Modal)`
  width: 320px !important;
`;

export const ListContainerDiv = styled.div<{ maxHeight: boolean }>`
  max-height: ${(props) => (props.maxHeight ? '10vh' : 'none')};
  min-height: 11vh;
  overflow-y: auto;
  width: 27vh;
`;


export const ListContainerItem = styled.div`
  margin: 2px 0px 0px 5px;
  color: ${(props) => props.theme.mode.productFamilies.textColor}
`;

export const AddProfileButton = styled(Button)`
  margin: 40px 20px 10px 35px;
  background-color: ${(props) => props.theme.mode.productFamilies.normalButtonBGColor} !important;
  border: 2px solid ${(props) => props.theme.mode.productFamilies.normalButtonBorderColor} !important;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: linear-gradient(to top left, #f0f0f5, ${(props) => props.theme.mode.productFamilies.backgroundColor});
  padding: 15px 20px 20px 20px;
  border-radius: 5px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  padding: 10px;
`;

export const StyledFormInput = styled(Input)`
  width: 14vw;
  border-bottom: 2px solid ${(props) => props.theme.mode.productFamilies.borderColor} !important;
  border-radius: 5px;
  padding: 10px;
  min-height: 30px !important;
`;

export const StyledFormSelect = styled(Select)`
  width: 14vw;
  min-height: 30px !important;
  margin-top: 10px;
   .ant-select-selector {
    border-bottom: 2px solid ${(props) => props.theme.mode.productFamilies.borderColor} !important;
    height: 30px !important;
    border-radius: 5px !important;
    padding: 10px !important;  // Adjust padding to align the border
  }
  .ant-select-selection-item {
    line-height: 28px;  // Adjust line-height to center text vertically
  }
`;

export const StyledFormWarningText = styled.div`
  margin-left: 10px;
  width: 100%;
  text-wrap: balance;
  fontSize: 11px;
  color: #ff0000;
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  margin-left: 20px;
  margin-top: 15px;
`;

export const CardListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;


export const StyledCard = styled(Card)<{ isHovered: boolean }>`
  margin: 10px 0px 10px 30px;
  box-shadow: ${(props) =>
    props.isHovered
      ? `${props.theme.mode.productFamilies.boxShadow} !important`
      : 'none !important'};
  border-radius: 10px;
  border-bottom: 4px solid ${(props) => props.theme.mode.productFamilies.borderColor} !important;
  transition: ${(props) =>
    props.isHovered
      ? 'transform 0.2s ease-in-out, box-shadow 0.3s ease, background 0.3s ease-in-out !important'
      : 'box-shadow 0.3s ease, background 1s ease-in-out !important'};
  background: ${(props) =>
    props.isHovered
      ? props.theme.mode.productFamilies.hoverBackgroundGradient
      : props.theme.mode.productFamilies.cardBackgroundGradient};
  color: ${(props) => props.theme.mode.productFamilies.textColor};
`;

export const CardTitle = styled.div<{ isHovered: boolean }>`
  font-size: 17px;
  color: ${(props) => props.theme.mode.productFamilies.textColor};
  background-color: ${(props) =>
    props.isHovered ? '#FFFFFF99' : '#FFFFFF55'};
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
  border-bottom: 1px solid ${(props) => props.theme.mode.productFamilies.borderColor};
`;

export const CardSubtitle = styled.div`
  margin-bottom: 5px;
  border-bottom: 1px solid ${(props) => props.theme.mode.productFamilies.borderColor};
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.mode.productFamilies.textColor};
`;

export const MenuContentArea = styled.div<{ isHovered: boolean }>`
  padding-top: 6px;
  border-radius: 5px;
  margin-left: 2px;
  transition: background-color 0.3s;
  background-color: ${(props) =>
    props.isHovered ? '#FFFFFF99' : '#FFFFFF55'};
`;

export const StyledSimpleList = styled(SimpleList)`
  overflow-y: auto;
  max-height: 40vh;
  border-color: #8b8b8c;
  border-radius: 5px;
`

export const SimpleListContainer = styled.div`
  margin-left: 15px;
  display: flex;
  padding: 5px;
  align-items: center;
`;

export const SimpleListFlexStartContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const SimpleListProductName = styled.div`
  width: max-content;
  margin-right: 5px;
  padding: 2px;
  background-color: #FFFFBB;
  border-radius: 5px;
  border: 1px solid #FF9900;
`;

export const SimpleListSeparator = styled.div`
  margin-right: 5px;
`;

export const SimpleListProductInfo = styled.div`
  width: max-content;
  padding: 2px;
  background-color: #AAFFAA;
  border-radius: 5px;
  border: 1px solid #00FF00;
`;

export const SimpleListButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const SimpleListStyledButton = styled(Button)`
  margin-left: auto;
`;

export const SimpleListHeader = styled.span`
  font-weight: bold;
  text-decoration: underline;
`;
